<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">绑定技师背景图</div>
      <el-form-item label="商户入住背景" :rules="[{required: true,message: '请选择技师背景图'}]">
        <el-button @click="chooseImg('image')">选择图片</el-button>
        <img class="mt10" v-img-url="form.supplier_image" width="100">
      </el-form-item>
     
      <el-form-item label="是否显示商家信息">
        <div>
          <el-radio v-model="form.store_open" label="1">显示</el-radio>
          <el-radio v-model="form.store_open" label="0">关闭</el-radio>
        </div>
        <!-- <div class="tips">主要用于微信小程序过审隐藏</div> -->
      </el-form-item>
   
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" :config="{ total: 3 }" @returnImgs="returnImgsFunc">
    </Upload>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import {
    formatModel
  } from '@/utils/base.js';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        /*是否正在加载*/
        loading: false,
        /*form表单数据*/
        form: {
          name: '',
          customer: '',
          key: '',
          supplier_cash: '',
          operate_type: '',
          commission_rate: '',
          supplier_image: '',
          sms_open: '',
          supplier_logo: '',
          checkedCities: [],
          edit_audit: 1,
          add_audit: 1,
          is_get_log: 0,
          service: '',
          privacy: '',
          store_open: '',
        },
        all_type: [],
        type: [],
        /*是否打开图片选择*/
        isupload: false
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.storeDetail({}, true).then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);

            self.form.checkedCities = res.data.vars.values.delivery_type;
            // 转成整数，兼容组件
            for (let i = 0; i < self.form.checkedCities.length; i++) {
              self.$set(self.form.checkedCities, i, parseInt(self.form.checkedCities[i]));
            }
            self.type = vars.delivery_type;
            self.form.customer = vars.kuaidi100.customer;
            self.form.key = vars.kuaidi100.key;
            self.form.service = vars.policy.service;
            self.form.privacy = vars.policy.privacy;
            self.all_type = res.data.all_type;
            self.loading = false;
          })
          .catch(error => {

          });
      },


      /*提交*/
      onSubmit() {
        let self = this;
       
          self.$message({
            message: '修改成功！',
            type: 'success'
          });
        
       

      },
      renumber(e) {
        var keynum = window.event ? e.keyCode : e.which;
        var keycar = String.fromCharCode(keynum);
        if (keynum == 189 || keynum == 190 || keynum == 110 || keynum == 109) {
          this.$message.warning("禁止输入小数和负数")
          e.target.value = ''
        }
      },
      /*选择图片*/
      chooseImg(e) {
        this.type = e;
        this.isupload = true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e) {
        this.isupload = false;
        if (e != null && e.length > 0) {
          if (this.type == 'logo') {
            this.form.supplier_logo = e[0].filePath;
          } else if (this.type == 'image') {
            this.form.supplier_image = e[0].filePath;
          }
        }
      }
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/views/channel/finance/index.vue